import React from 'react'
import { Updater } from 'widgets-for-react'
import { any, async, fromJSX, nothing, onlyIf, Widget } from 'widgets-for-react'
import {
  ProcessedResearch,
  ResearchPerPatientsNeeded,
  ResearchOverviewState,
  researchOverviewStateUpdaters,
} from './researchOverviewState'
import { AZNavigationLayoutProps } from '../azNavigation/azNavigationLayout'
import i18next from 'i18next'
import { ResearchOverviewHeaderLayout, ResearchOverviewSectionLayout } from './researchOverviewLayout'
import { azNavigationWidget } from '../azNavigation/azNavigationWidget'

export const researchOverviewWidget = (state: ResearchOverviewState): Widget<Updater<ResearchOverviewState>> =>
  any<Updater<ResearchOverviewState>>([
    async<ResearchPerPatientsNeeded>(state.researchPerPatientsState).map(
      researchOverviewStateUpdaters.updateResearchPerPatientsNeededState
    ),
    //header
    onlyIf(
      state.researchPerPatientsState.kind == 'loaded',
      fromJSX(() => (
        <ResearchOverviewHeaderLayout
          breadcrumbs={[
            { title: 'Spaarne Gasthuis', url: '/' },
            { title: 'Wetenschappelijke onderzoeken', url: '/wetenschappelijke-onderzoeken' },
          ]}
        />
      ))
    ),
    //research patients needed
    onlyIf(
      state.researchPerPatientsState.kind == 'loaded',
      async<ProcessedResearch>(state.patientsProcessedResearchState).map(
        researchOverviewStateUpdaters.updatePatientsProcessedResearchState
      )
    ),
    state.patientsProcessedResearchState.kind == 'loaded'
      ? loadedPatientsWidget(state, state.patientsProcessedResearchState.value)
      : nothing(),

    //research no patients needed
    onlyIf(
      state.researchPerPatientsState.kind == 'loaded',
      async<ProcessedResearch>(state.noPatientsProcessedResearchState).map(
        researchOverviewStateUpdaters.updateNoPatientsProcessedResearchState
      )
    ),
    state.noPatientsProcessedResearchState.kind == 'loaded'
      ? loadedNoPatientsWidget(state, state.noPatientsProcessedResearchState.value)
      : nothing(),
  ])

const loadedPatientsWidget = (
  state: ResearchOverviewState,
  data: ProcessedResearch
): Widget<Updater<ResearchOverviewState>> => {
  const paginationProps: AZNavigationLayoutProps = {
    title: i18next.t('misc:researchOverviewPaginationTitle'),
    intro: i18next.t('misc:researchOverviewPaginationIntro'),
    showFilter: true,
    enabledLetters: data.groups.map((g) => g.letter),
  }

  return any<Updater<ResearchOverviewState>>([
    azNavigationWidget(paginationProps)(state.patientsNavigationState).map(
      researchOverviewStateUpdaters.updatePatientsNavigationState
    ),
    fromJSX(() => <ResearchOverviewSectionLayout researches={data.groups} />),
  ])
}

const loadedNoPatientsWidget = (
  state: ResearchOverviewState,
  data: ProcessedResearch
): Widget<Updater<ResearchOverviewState>> => {
  const paginationProps: AZNavigationLayoutProps = {
    title: i18next.t('misc:researchOverviewNoPatientsPaginationTitle'),
    intro: i18next.t('misc:researchOverviewNoPatientsPaginationIntro'),
    showFilter: true,
    enabledLetters: data.groups.map((g) => g.letter),
    secondPagination: true,
  }

  return any<Updater<ResearchOverviewState>>([
    azNavigationWidget(paginationProps)(state.noPatientsNavigationState).map(
      researchOverviewStateUpdaters.updateNoPatientsNavigationState
    ),
    fromJSX(() => <ResearchOverviewSectionLayout researches={data.groups} />),
  ])
}
